import React, { Fragment } from 'react'
import clsx from 'clsx'
import { Link as RouterLink } from 'react-router-dom'

import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import headerImage from '../../assets/images/header/header-image.png'

// import { origins } from '../../constants'

// import { useApplicationVariantKey } from '../hooks/useApplicationVariants'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(0, 2),
  },
  content: {
    width: 'auto',
  },
  cardMedia: {
    width: '100%',
  },
  actionCard: {
    height: '100%',
    transform: 'scale(1)',
    transition: ['transform'],
    transitionDuration: 300,
    '&:hover': {
      transform: 'scale(1.04)',
    },
  },
  actionCardDisabled: {
    '&:hover': {
      transform: 'scale(1)',
    },
  },
  actionCardArea: {
    height: '100%',
    padding: '0 !important',
  },
  actionLink: {
    display: 'flex',
    height: '100%',
  },
  actionBox: {
    alignItems: 'stretch',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  actionBoxHeader: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: theme.spacing(8),
    justifyContent: 'center',
  },
  actionBoxTextDisabled: {
    color: theme.palette.text.disabled,
  },
  actionBoxDivider: {
    backgroundColor: theme.palette.primary.main,
    height: 2,
    margin: theme.spacing(0, 2),
  },
  actionBoxDividerDisabled: {
    backgroundColor: theme.palette.text.disabled,
  },
  actionBoxBody: {
    alignItems: 'start',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  backButtonContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    marginTop: theme.spacing(6),
  },
  backButton: {
    color: '#ffffff',
    textDecoration: 'underline',
  },
})
const useStyles = makeStyles(styles)

function ActionBoxGridItem(props) {
  const { body, disabled = false, subtitle, title, to } = props

  const classes = useStyles()

  const actionBox = (
    <div className={classes.actionBox}>
      <div className={classes.actionBoxHeader}>
        <Typography
          className={clsx(disabled && classes.actionBoxTextDisabled)}
          variant="h6"
        >
          {title}
        </Typography>

        <Typography
          className={clsx(disabled && classes.actionBoxTextDisabled)}
          variant="subtitle2"
        >
          {subtitle}
          {disabled && (
            <Fragment>
              {!!subtitle && <br />}
              (inscrições fechadas)
            </Fragment>
          )}
        </Typography>
      </div>

      <div
        className={clsx(
          classes.actionBoxDivider,
          disabled && classes.actionBoxDividerDisabled,
        )}
      />

      <div
        className={clsx(
          classes.actionBoxBody,
          disabled && classes.actionBoxTextDisabled,
        )}
      >
        <Typography component="div" variant="body2">
          {body}
        </Typography>
      </div>
    </div>
  )

  const ContentComponent = disabled ? CardContent : CardActionArea

  return (
    <Fragment>
      <Grid item xs={12} md={4}>
        <Card
          className={clsx(
            classes.actionCard,
            disabled && classes.actionCardDisabled,
          )}
        >
          <ContentComponent className={classes.actionCardArea}>
            {!disabled && (
              <Link
                className={classes.actionLink}
                color="inherit"
                component={RouterLink}
                underline="none"
                to={to}
              >
                {actionBox}
              </Link>
            )}

            {!!disabled && (
              <Typography
                component="div"
                className={classes.actionLink}
                color="inherit"
              >
                {actionBox}
              </Typography>
            )}
          </ContentComponent>
        </Card>
      </Grid>
    </Fragment>
  )
}

export default function GreetingsScreen() {
  const classes = useStyles()

  // const individualOriginIdentifier = useApplicationVariantKey(
  //   origins.individualOriginIdentifier,
  //   'isRegistrationOpen',
  // )
  // const mentorOriginIdentifier = useApplicationVariantKey(
  //   origins.mentorOriginIdentifier,
  //   'isRegistrationOpen',
  // )

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item sm={12} lg={9} xl={6}>
            <Card>
              <img
                alt="Header"
                className={classes.cardMedia}
                src={headerImage}
              />

              <CardContent>
                <Typography
                  align="center"
                  className={classes.heading}
                  component="h2"
                  gutterBottom
                  paragraph
                  variant="h6"
                >
                  Escolha como você quer se inscrever:
                </Typography>

                <Grid container justify="center" spacing={2}>
                  <ActionBoxGridItem
                    body={
                      <div>
                        <Typography gutterBottom variant="body2">
                          Alunos do Ensino Técnico ou da Graduação do IFRJ que
                          queiram resolver os desafios
                        </Typography>
                      </div>
                    }
                    disabled
                    title="PARTICIPANTE"
                    to="/participante"
                  />

                  <ActionBoxGridItem
                    body={
                      <div>
                        <Typography variant="body2">
                          Professores, profissionais ou pós graduandos do IFRJ
                          que desejam auxiliar as equipes com seus conhecimentos
                        </Typography>
                      </div>
                    }
                    disabled
                    title="MENTOR(A)"
                    to="/mentores"
                  />
                </Grid>

                {/* <Fragment>
                  <br />
                  <br />
                  <Typography
                    align="center"
                    className={classes.heading}
                    component="h2"
                    gutterBottom
                    paragraph
                    variant="h6"
                  >
                    <Link href="https://hackiff.com.br/">
                      Ir para o site do HackIFF e ver mais informações
                    </Link>
                  </Typography>
                </Fragment> */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
